// extracted by mini-css-extract-plugin
export var root = "profile-recent-badge-module--root--n79WY";